export default __webpack_public_path__ + "static/8-87000fb43cbf9635e0980d82feea140f.png";